"use strict";
/**
 * SignalHire Search API shapes shared by the API and worker clients.
 * Docs: https://docs.signalhire.com/search-api/search-by-query
 */
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=signalhire.js.map